import React from 'react';
import TransactionDetailsView from 'spa/containers/PartnerDashboard/TransactionDetails';

const TransactionDetails = () => <TransactionDetailsView />;

export default TransactionDetails;
